
export default {
    name: 'ImageViewer',

    layout: 'footerless',

    transition: {
        css: false,
    },

    data() {
        return {
            collection: false,
            parent: false,
            currentImageData: {},
            currentImage: {
                src: '',
                id: '',
                slug: '',
                name: '',
            },
            zoom: false,
            selectedIndex: null,
            imageHeight: undefined,
        }
    },

    computed: {
        imageCollection() {
            return this.$route.params.collection || this.collection
        },

        hasImageCollection() {
            return this.imageCollection?.length > 0
        },

        taxonomy() {
            const arr = []
            if (this.currentImageData && this.currentImageData.taxonomy) arr.push(...this.currentImageData.taxonomy)
            if (this.parent && this.parent.taxonomy) arr.push(...this.parent.taxonomy)
            return arr
        },

        vendors() {
            return this.taxonomy.filter((el) => this.contentTypeLookup(el, 'vendors'))
        },

        photographers() {
            return this.vendors.filter((el) => el.metas && el.metas.is_photographer && (el.metas.is_photographer === '1' || el.metas.is_photographer === 1))
        },

        photographer() {
            return this.photographers && this.photographers.length ? this.photographers[0] : null
        },

        colors() {
            return this.taxonomy.filter((el) => this.contentTypeLookup(el, 'colors'))
        },

        styles() {
            return this.taxonomy.filter((el) => this.contentTypeLookup(el, 'styles'))
        },

        seasons() {
            return this.taxonomy.filter((el) => this.contentTypeLookup(el, 'seasons'))
        },

        style() {
            return this.styles?.length ? this.styles[0] : undefined
        },

        season() {
            return this.seasons?.length ? this.seasons[0] : undefined
        },

        documentId: {
            get() {
                return this.$route.params.id || this.$route.params.parent
            },

            set(val) {
                this.$router.push({ params: { ...this.$route.params, id: val, collection: this.imageCollection } })
            },
        },

        parentBoard() {
            return this.$route.params.username
                ? { name: 'users-username-boards-id', params: { id: this.$route.params.parent, username: this.$route.params.username } }
                : null
        },

        parentUrl() {
            return this.parent && !this.parentBoard ? `/${this.parent.content_type.slug}/${this.parent.slug}` : null
        },

        parentApiBase() {
            return this.parentBoard
                ? this.$route.params.username === 'loverly'
                    ? '/api/v1/public/users/boards/'
                    : 'api/v1/users/me/boards/'
                : '/api/v1/content?id='
        },
        smDevice() {
            return this.$store.getters["data/smDevice"]
        },

        title() {
            return this.currentImage ? this.currentImage.name : this.parent ? this.parent.name : this.parentBoard?.name || ''
        },
    },

    async mounted() {
        window.addEventListener('keyup', this.onKeyUp)

        if (this.$route.params.parent) {
            await this.getCollection()
            if (this.hasImageCollection) this.setCurrentImage()
            else await this.getDocument()
        } else if (this.hasImageCollection) {
            this.setCurrentImage()
        } else {
            if (this.parentBoard) this.getParent()
            this.getDocument()
        }
    },

    beforeDestroy() {
        window.removeEventListener('keyup', this.onKeyUp)
    },

    methods: {
        getImage(obj) {
            return { src: obj.cover.url, id: obj.id, slug: obj.slug, name: obj.name, content_type: obj.content_type }
        },
        async getDocument() {
            try {
                const result = await this.$axios.$get(`/api/v1/content?id=${this.documentId}`)
                this.currentImageData = result.data || {}
                this.currentImage = this.getImage(result.data)
            } catch (e) {
                return e
            }
        },

        async getParent() {
            try {
                const result = await this.$axios.$get(`${this.parentApiBase}${this.$route.params.parent}`)
                this.parent = result.data
                return result
            } catch (e) {
                return e
            }
        },

        async getCollection() {
            try {
                const result = await this.getParent()
                if (result.data.content_type.slug === 'vendors')
                    this.collection =
                        result.data.taxonomy?.filter((el) => el.content_type.slug === 'wedding-inspiration').map((el) => this.getImage(el)) || false
                else this.collection = result.data.children?.map((el) => this.getImage(el)) || false
            } catch (e) {
                return e
            }
        },

        selectImage(image) {
            this.documentId = image.id.toString()
        },

        setCurrentImage() {
            this.currentImage = this.imageCollection.find((el, index) => {
                if (el.id.toString() === this.$route.params.id.toString()) {
                    this.selectedIndex = index
                    return true
                }
            })
        },

        toggleZoom(e) {
            if (!this.smDevice) this.zoom = !this.zoom
            this.imageHeight = this.zoom ? (e.target.naturalHeight > window.innerHeight ? window.innerHeight - 128 : e.target.naturalHeight - 128) : undefined
        },

        prev() {
            if (this.hasImageCollection) {
                const prevImage = this.imageCollection[this.selectedIndex - 1]
                this.selectImage(prevImage)
            }
        },

        next() {
            if (this.hasImageCollection) {
                const nextImage = this.imageCollection[this.selectedIndex + 1]
                this.selectImage(nextImage)
            }
        },

        onKeyUp(e) {
            if (e.key === 'ArrowLeft' && this.selectedIndex !== 0) {
                this.prev()
            }

            if (e.key === 'ArrowRight' && this.selectedIndex !== this.imageCollection.length - 1) {
                this.next()
            }
        },

        contentTypeLookup(obj, slug) {
            return obj && obj.content_type ? this.contentTypeLookupRecursive(obj.content_type, slug) : false
        },

        contentTypeLookupRecursive(obj, slug) {
            return obj && obj.slug === slug ? true : obj && obj.parent ? this.contentTypeLookupRecursive(obj.parent, slug) : false
        },

        handleClickOutside() {
            if (this.zoom) this.toggleZoom()
        },
    },
}
